import axios from 'axios';
import { store } from './store';
import {Campaign} from "@/types";

export const fetchRegionalCampaigns = () => {
    return axios.get(
        `${process.env.VUE_APP_API_URI}/api/admin/weblinks/regional`
    );
};

export const fetchAdminCampaigns = () => {
    return new Promise<any[]>((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_API_URI}/api/admin/weblinks/admin`).then((res) => {
            if ((res.status = 200)) {
                const campaigns = res.data.map((campaign) => ({
                    ...campaign,
                    readWrite: false,
                }));
                setAdminCampaigns(campaigns.map((c) => c.path));
                resolve(campaigns);
            }
            else {
                reject();
            }
        });
    });

};

export const setHasAdminCampaigns = (hasAdminCampaigns: boolean) => {
    store.hasAdminCampaigns = hasAdminCampaigns || false;
};

export const setAdminCampaigns = (adminCampaigns: string[]) => {
    store.adminCampaigns = adminCampaigns || [];
    setHasAdminCampaigns(adminCampaigns.length > 0);
}

export const getAllSignUps = () => {
    return axios.get(
        `${process.env.VUE_APP_API_URI}/api/admin/signups/getAll`
    ); 
}
